<script setup lang="ts">
import BrandMark from '@/ui/BrandMark.vue'
import AppFooter from '@/ui/AppFooter.vue'
</script>

<template>
  <div class="auth">
    <header class="auth__header">
      <BrandMark size="lg" />
    </header>
    <main id="main" class="auth__main">
      <slot />
    </main>
    <AppFooter />
  </div>
</template>

<style scoped>
.auth {
  min-height: 100vh;
  min-height: 100dvh;
  display: flex;
  flex-direction: column;
  background: var(--color-bg);
}

.auth__header {
  display: flex;
  justify-content: center;
  padding: var(--space-6) var(--content-padding-x) var(--space-4);
}

.auth__main {
  flex: 1;
  display: grid;
  place-items: start center;
  padding: var(--space-6) var(--content-padding-x) var(--space-8);
}

@media (max-width: 640px) {
  .auth__header {
    padding-top: var(--space-4);
  }

  .auth__main {
    padding: var(--space-4) var(--content-padding-x) var(--space-6);
  }
}
</style>
